import React from 'react';
import { ShieldCheckIcon, ClockIcon, CheckCircle2Icon, LockIcon } from 'lucide-react';
import { trackAddToCart } from '../lib/pixel';
export function OfferSection() {
  return <section id="oferta" className="py-20 bg-[#0a0f1e] relative overflow-hidden" data-id="element-129">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#00d4ff]/5 rounded-full blur-3xl pointer-events-none" data-id="element-130"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 relative z-10 text-center" data-id="element-131">
        <span id="oferta-heading" className="block scroll-mt-8 text-[#00d4ff] font-semibold tracking-widest uppercase text-sm" data-id="element-132">
          Oferta de Lanzamiento
        </span>
        <h2 className="font-heading text-4xl md:text-6xl font-bold text-white mt-2 mb-4 uppercase" data-id="element-133">
          Recupera el Control Hoy
        </h2>
        <p className="text-slate-300 text-lg mb-12" data-id="element-134">
          Solo por tiempo limitado al precio de lanzamiento
        </p>

        {/* Offer Box */}
        <div id="precio" className="bg-[#0d1529] rounded-2xl p-8 md:p-12 shadow-2xl mb-10 border border-[#00d4ff]/30 max-w-2xl mx-auto" data-id="element-135">
          <div className="inline-block bg-[#00d4ff]/10 text-[#00d4ff] border border-[#00d4ff]/30 px-4 py-1 rounded-full text-sm font-bold mb-6 tracking-wider uppercase" data-id="element-136">
            Acceso Digital Inmediato
          </div>

          {/* Price */}
          <div className="flex justify-center items-baseline mb-4 gap-4" data-id="element-137">
            <div className="flex flex-col items-end" data-id="element-138">
              <span className="text-xs text-slate-400 uppercase tracking-wider mb-1" data-id="element-139">
                Precio normal
              </span>
              <span className="text-2xl font-bold text-slate-400 line-through decoration-red-400 decoration-2" data-id="element-140">
                $67 USD
              </span>
            </div>
            <div className="flex flex-col items-start" data-id="element-141">
              <span className="text-xs text-[#00d4ff] uppercase tracking-wider mb-1" data-id="element-142">
                Precio lanzamiento
              </span>
              <div className="flex items-baseline gap-2" data-id="element-143">
                <span className="font-heading text-5xl font-bold text-white" data-id="element-144">
                  $6,39
                </span>
                <span className="text-lg text-slate-400" data-id="element-145">USD</span>
              </div>
            </div>
          </div>

          {/* Discount Badge */}
          <div className="flex justify-center mb-8" data-id="element-146">
            <div className="inline-flex items-center gap-1.5 bg-green-500/15 border border-green-500/40 text-green-400 px-2.5 py-0.5 rounded-full text-xs font-bold tracking-wider uppercase" data-id="element-147">
              <span className="w-1.5 h-1.5 bg-green-400 rounded-full" data-id="element-148"></span>
              90% OFF
            </div>
          </div>

          {/* Included items */}
          <ul className="text-left space-y-4 mb-10 max-w-md mx-auto" data-id="element-149">
            {['Sistema Plan B: Cuerpo 4.0 (acceso inmediato)', 'Checklist de 7 Días — Bio-Clock Reset', 'Protocolo de Cenas Sociales', 'Guía de Movimiento Inteligente (15 min)', 'Guía de Suplementación 40+'].map(item => <li key={item} className="flex items-center" data-id="element-150">
                <CheckCircle2Icon className="w-5 h-5 text-[#00d4ff] mr-3 shrink-0" data-id="element-151" />
                <span className="text-slate-200 font-medium" data-id="element-152">{item}</span>
              </li>)}
          </ul>

          {/* CTA Button */}
          <a href="https://www.recursosencalma.com/cart/45752293621933:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="cta-pulse block w-full bg-[#00d4ff] hover:bg-[#0099cc] text-[#0a0f1e] font-heading font-bold text-xl md:text-2xl uppercase tracking-wider px-8 py-5 rounded-xl transition-colors duration-200 mb-4" data-id="element-153">
            SÍ, QUIERO MI PLAN B: CUERPO 4.0 →
          </a>

          <div className="flex items-center justify-center gap-2 text-slate-400 text-sm" data-id="element-154">
            <LockIcon className="w-4 h-4" data-id="element-155" />
            <span data-id="element-156">
              Pago 100% seguro · Acceso inmediato · Garantía de resultados
            </span>
          </div>
        </div>

        {/* Guarantee */}

        <div className="mt-10 flex items-center justify-center gap-2 text-slate-500 text-sm" data-id="element-157">
          <ClockIcon className="w-4 h-4" data-id="element-158" />
          <span data-id="element-159">La oferta especial de lanzamiento termina pronto.</span>
        </div>
      </div>
    </section>;
}